export default __webpack_public_path__ + "static/media/01AW2FEB66.94f0c8c9.jpg";